import travelObject from '@/entities/travel/interface'
import { TFunction } from 'next-i18next'

export const buildSecondaryLabel = (travel: travelObject, t: TFunction) => {
  let label = ''
  if (travel.accommodationAssignments.length) {
    travel.accommodationAssignments.map((accommodationAssignment, index: number) => {
      label += `${index > 0 ? ' / ' : ''}${accommodationAssignment.accommodation.name}`
    })
  }
  return label
}
